// import { fetchJSON, postJSON } from "../utils/HttpUtils";
// import { fromatDateForUrl, formatTimeSlotForUrl } from "../utils/Format";
// import { validateEmail, validateTelephoneNumber } from "../utils/Validators";
// import { faRulerHorizontal } from "@fortawesome/free-solid-svg-icons";

// const defaultTermsAndConditions = true;

// const getParameterByName = (name, url = window.location.href) => {
//     name = name.replace(/[\[\]]/g, '\\$&');
//     var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
//         results = regex.exec(url);
//     if (!results) return null;
//     if (!results[2]) return '';
//     return decodeURIComponent(results[2].replace(/\+/g, ' '));
// }

class BookingProcess {
    step = 1;

    // date = null;
    // venue = null;
    // timeSlot = null;
    // guests = null;
    // children = null;
    // sessions = null;
    // showCrossSell = false;
    // venueAvailability = null;
    // confirmedTimeSlot = false;
    // confirmedMenu = false;
    // menus = null;
    // menusAvailable = false;
    // menu = null;
    // showMenuError = false;
    // specialRequests = null;
    // firstName = null;
    // lastName = null;
    // telephoneNumber = null;
    // email = null;
    // optIn = false;
    // termsAndConditions = defaultTermsAndConditions;
    // confirmations = [];
    // questions = [];

    // showFirstNameError = false;
    // showLastNameError = false;
    // showTelephoneNumberError = false;
    // showEmailError = false;
    // showTermsAndConditionsError = false;
    // showAdditionalGuestsError = false;

    // requestRunning = false;
    // error = false;
    // errorText = null;
    // errors = null;

    // complete = true;

    // enquiry = false;
    // enquiryReference = null;

    // requiresCcg = false;
    // ccgPerformed = false;
    // paymentClientToken = '';
    // ccgTermsAndConditions = false;
    // showCcgTermsAndConditionsError = false;

    // numberOfAdults = 0;
    // invalidAdult = null;
    // additionalGuestSelected = false;

    // insideOrOutside = null;
    // adults = [];

    constructor() {
    
        
    }

    setStep = (i) => {
        this.step = i;
    
        // COMMENT THS LINE IN TO SKIP TO STEP 3
    //     //this.initializeVenue("95288707-f468-473b-9cbf-5cf3830eb080");


    //     //  hook for external accxess
    //     window.mw = window.mw || {};
    //     window.mw.showPopup = async (venueId, date, adults, children, time) => {
    //         var urlParams = new URLSearchParams(window.location.search);
    //         var lockVenue = false;
    //         if (!venueId && urlParams.has('venueId')) {
    //             venueId = urlParams.get('venueId');
    //             lockVenue = true;
    //         }
    //         await this.initializeVenue(venueId, date, adults, children, time, lockVenue);
    //         this.complete = false;
    //         document.body.scrollTop = document.documentElement.scrollTop = 0;
    //     };
    // }

    // restartBookingProcess = (rememberValues) => {
    //     if (rememberValues) {
    //         this.showCrossSell = false;
    //         this.confirmedTimeSlot = false;
    //         this.confirmedMenu = false;
    //         this.menu = null;
    //         this.menusAvailable = false;
    //         this.menus = null;
    //         this.termsAndConditions = defaultTermsAndConditions;
    //         this.enquiry = false;
    //         this.optIn = false;
    //         this.requiresCcg = false;
    //         this.confirmations = [];
    //         this.questions = [];
    //         this.ccgPerformed = false;
    //         this.bookingReference = null;
    //         this.enquiryReference = null;
    //         this.showTelephoneNumberError = false;
    //         this.showTermsAndConditionsError = false;
    //         this.showCcgTermsAndConditionsError = false;
    //         this.showEmailError = false;
    //         this.showFirstNameError = false;
    //         this.showLastNameError = false;
    //         this.showMenuError = false;
    //         this.numberOfAdults = 0;
    //         this.adults = [];
    //         this.showAdditionalGuestsError = false;
    //     }
    // }

    
    // getVenue = async (venueId, date) => {
    //     const  urlParams = new URLSearchParams(window.location.search);
    //     const spa = urlParams.get('spa');
    //     if (date) {
    //         return await fetchJSON(`/api/venues/getbyidanddate/${venueId}/${fromatDateForUrl(date)}?specialAvailabilityCode=${spa}`);
    //     }
    //     else {
    //         return await fetchJSON(`/api/venues/getbyid/${venueId}?specialAvailabilityCode=${spa}`);
    //     }
    // }

    // getSessionAvailability = async (venueId, date, guests, children) => {
    //     const  urlParams = new URLSearchParams(window.location.search);
    //     const  spa = urlParams.get('spa');
    //     return await fetchJSON("/api/sessions/availability/" + this.venue.id + "/" + fromatDateForUrl(this.date) + "/" + guests + "?children=" + (children || 0) + "&specialAvailabilityCode=" + spa);
    // }

    // getVenuesSearchAvailability = async () => {
    //     const  urlParams = new URLSearchParams(window.location.search);
    //     const  spa = urlParams.get('spa')
    //     return await fetchJSON(`/api/venues/searchavailability/${this.venue.id}/${fromatDateForUrl(this.date)}/${formatTimeSlotForUrl(this.timeSlot)}/${this.guests}?children=${this.children || 0}&specialAvailabilityCode=${spa}`);
    // }

    // initializeVenue = async (venueId, date, adults, children, time, lockVenue) => {
    //     if (venueId) {
    //         const  urlParams = new URLSearchParams(window.location.search);
    //         const spa = urlParams.get('spa');
    //         const venue = await this.getVenue(venueId);
    //         if (venue && venue.status == 200) {
    //             this.setBookingParameters(venue, date, adults, time, children, lockVenue);
    //         }
    //     }
    //     else {
    //         this.setBookingParameters(null, date, adults, time, children);
    //     }
    // }

    // setBookingParameters = async (venue, date, guests, timeSlot, children, lockVenue) => {
    //     this.restartBookingProcess(true);
        
    //     if (typeof (lockVenue) == 'boolean') {
    //         this.lockVenue = lockVenue;
    //     } else {
    //         this.lockVenue = false;
    //     }

    //     if (venue) {
    //         this.selectVenue(venue.json);
    //         //
    //         //

    //         //  Don't allow auto select of closed date
    //         var venueAvailability = venue.json.availabilityWindows;
    //         var dateIsAvailable = true;

    //         if (venueAvailability) {
    //             dateIsAvailable = false;
    //             for (var i = 0; i < venueAvailability.length; i++) {
    //                 if (dateIsAvailable == true) break;
    //                 var availabilityWindow = venueAvailability[i];
    //                 if ((availabilityWindow.from === null || new Date(availabilityWindow.from) <= date) &&
    //                     (availabilityWindow.to === null || new Date(availabilityWindow.to) >= date)) {
    //                     dateIsAvailable = true;
    //                 }
    //             }
    //         }

    //         if (!dateIsAvailable) return;

    //         await this.selectDate(date);
    //         await this.selectGuests(guests, children);
    //         this.selectTimeSlot(timeSlot);
    //         if (timeSlot != null) {
    //             await this.checkVenueAvailability();
    //         }
    //         else {
    //             this.confirmedTimeSlot = false;
    //             this.menusAvailable = false;
    //             this.menus = null;
    //             this.enquiry = false;
    //             this.enquiryReference = null;
    //             this.bookingReference = null;
    //             this.menu = null;
    //         }
    //     }
    // }

    // selectNewVenueAndTimeSlot = async (venue, timeSlot) => {
    //     this.venue = venue;
    //     this.timeSlot = timeSlot;
    //     await this.selectGuests(this.guests, this.children, false);
    //     await this.checkVenueAvailability();

    // }

    // selectVenue = (venue, resetParameters) => {
    //     this.venue = venue;
    //     if (resetParameters) {
    //         this.date = null;
    //         this.timeSlot = null;
    //         this.guests = null;
    //         this.children = null;
    //         this.sessions = null;
    //     }
    // }


    // selectDate = async (date) => {

    //     //  clamp it to midnight
    //     if (date != null) {
    //         date.setHours(0, 0, 0, 0);

    //         var venue = await this.getVenue(this.venue.id, date);
    //         if (venue && venue.status == 200) {
    //             this.selectVenue(venue.json);
    //         }
    //     }

    //     this.date = date;
    //     this.timeSlot = null;
    //     this.guests = null;
    //     this.children = null;
    //     this.sessions = null;
    // }

    // selectGuests = async (guests, children, resetParameters) => {

    //     var availableWindow = this.venue.availabilityWindows.filter(a => {
    //         return (a.from != null && new Date(a.from) <= this.date) &&
    //         (a.to != null && new Date(a.to) >= this.date);
        
    //     });

    //     if (resetParameters) {
    //         this.timeSlot = null;
    //         this.insideOrOutside = this.venue.configuration.outsideSpace !== true ? "Inside" : null;
    //     }

    //     try {
    //         if (guests != null) {
    //             //this.requestRunning = true;
    //             //
    //             //  at the point we are here we can query
    //             var sessions = await this.getSessionAvailability(this.venue.id, this.date, guests, children);
    //             if (sessions.status == 200) {
    //                 //  valid
    //                 this.sessions = sessions.json;
    //                 this.guests = guests;
    //                 this.children = children;
    //                 this.setNumberOfAdults(0);
    //             }
    //             else {
    //                 this.error = true;
    //                 this.errorText = "Sorry, there was a problem checking availability at " + this.venue.name + ".";
    //                 this.errors = [];
    //             }
    //         }
    //     }
    //     catch (e) {
    //         this.error = true;
    //         this.errorText = "Sorry, there was a problem checking availability at " + this.venue.name + ".";
    //         this.errors = [];
    //     }
    //     finally {
    //         this.requestRunning = false;
    //     }
    // }


    // selectTimeSlot = (timeSlot) => {
    //     this.timeSlot = timeSlot;
    // }

    // checkVenueAvailability = async () => {
    //     try {
    //         this.requestRunning = true;
    //         this.enquiry = false;
    //         //
    //         //  

    //         var venueAvailability = await this.getVenuesSearchAvailability();
    //         if (venueAvailability.status == 200) {
    //             this.venueAvailability = venueAvailability.json;

    //             if (venueAvailability.json.noAvailability) {
    //                 this.error = true;
    //                 this.errorText =
    //                     this.venue.configuration.noAvailabilityMessage ||
    //                     "No availability found at " + this.venue.name + " or near by restaurants.";
    //                 this.errors = [];
    //             }
    //             else if (venueAvailability.json.originalChoiceAvailable == false) {
    //                 this.showCrossSell = true;
    //             }
    //             else {
    //                 this.showCrossSell = false;
    //                 this.venue = this.venueAvailability.venues[0];
    //                 //
    //                 //  we have a confirmed timeslot, it is usually here we capture the menus
    //                 await this.getMenus();

    //                 this.confirmedTimeSlot = true;
    //             }

    //         }
    //     }
    //     finally {
    //         this.requestRunning = false;
    //     }

    // }

    // selectMenu = (menu) => {
    //     this.menu = menu;
    //     if (this.showMenuError)
    //         this.showMenuError = false;
    // }

    // confirmEnquiry = async () => {
    //     this.enquiry = true;
    // }

    // confirmMenu = async () => {
    //     if (this.menu == null) {
    //         this.showMenuError = true;
    //     }
    //     else {
    //         this.confirmedMenu = true;
    //     }
    // }

    // getMenus = async () => {
    //     try {
    //         //this.requestRunning = true;
    //         var menus = await fetchJSON(`/api/menus/search/${this.venue.id}/${fromatDateForUrl(this.date)}/${this.guests}/${formatTimeSlotForUrl(this.timeSlot)}`);
    //         if (menus.status == 200) {
    //             this.menus = menus.json;
    //             this.menusAvailable = (menus.json.length > 0)
    //         }
    //     }
    //     finally {
    //         this.requestRunning = false;
    //     }
    // }

    // initializeCcgProcess = async () => {
    //     var clientTokenResult = await fetchJSON("/api/payment/getclienttoken")
    //     if (clientTokenResult.status == 200) {
    //         this.paymentClientToken = clientTokenResult.json.clientToken;
    //         this.requiresCcg = true;
    //     } else {
    //         //  handle braintree initialization error
    //     }
    // }

    // completeBookingWithCcg = async (hostedFields) => {
    //     this.requestRunning = true;

    //     hostedFields.tokenize(async (err, payload) => {
    //         if (err) {
    //             this.requestRunning = false;
    //         }
    //         else {
    //             //send the nonce and complete the payment
    //             await this.completeBooking(payload.nonce)
    //         }
    //     });
    // }

    // completeBooking = async (paymentNonce) => {
    //     if(this.guests > 11 & paymentNonce == null && this.date > new Date('2022-11-14') && this.date < new Date('2023-01-03')) {
    //         this.initializeCcgProcess();
    //         return;
    //     }
    //     if (this.firstName == null || this.firstName.trim() == '')
    //         this.showFirstNameError = true;
    //     if (this.lastName == null || this.lastName.trim() == '')
    //         this.showLastNameError = true;
    //     if (this.telephoneNumber == null || this.telephoneNumber.trim() == '' || !validateTelephoneNumber(this.telephoneNumber))
    //         this.showTelephoneNumberError = true;
    //     if (this.email == null || this.email.trim() == '' || !validateEmail(this.email))
    //         this.showEmailError = true;

    //     var adultValidationVisible = false;
    //     if (this.venue.configuration.enableCaptureAdults && this.guests > 1) {
    //         if (this.adults.length == 0) {
    //             adultValidationVisible = !this.additionalGuestSelected;
    //             this.showAdditionalGuestsError = !this.additionalGuestSelected;
    //         }
    //         this.invalidAdult = null;
    //         this.adults.forEach((adult, index) => {
    //             if (adult.firstName == null || adult.firstName.trim() == '')
    //                 adult.showFirstNameError = true;
    //             if (adult.lastName == null || adult.lastName.trim() == '')
    //                 adult.showLastNameError = true;
    //             if (adult.telephoneNumber == null || adult.telephoneNumber.trim() == '' || !validateTelephoneNumber(adult.telephoneNumber))
    //                 adult.showTelephoneNumberError = true;

    //             adultValidationVisible = adultValidationVisible | adult.showTelephoneNumberError | adult.showFirstNameError | adult.showLastNameError;

    //             if (adultValidationVisible && this.invalidAdult === null)
    //                 this.invalidAdult = index;
    //         })
    //     }

    //     this.validateTermsAndConditions();
    //     /*if (!this.termsAndConditions)
    //         this.showTermsAndConditionsError = true;*/

    //     //  ensure we are valid
    //     if (!this.showFirstNameError && !this.showLastNameError && !this.showTelephoneNumberError && !this.showEmailError && !this.showTermsAndConditionsError && !adultValidationVisible) {
    //         try {
    //             this.requestRunning = true;
    //             const  urlParams = new URLSearchParams(window.location.search);
    //             const spa = urlParams.get('spa');
    //             //  ok, we are valid... time to do a post
    //             var result = await postJSON("/api/bookings/create", {
    //                 venueId: this.venue.id,
    //                 date: fromatDateForUrl(this.date),
    //                 time: formatTimeSlotForUrl(this.timeSlot),
    //                 guests: this.guests,
    //                 children: this.children,
    //                 menuId: this.menu != null ? this.menu.id : null,
    //                 email: this.email,
    //                 firstName: this.firstName,
    //                 lastName: this.lastName,
    //                 telephoneNumber: this.telephoneNumber,
    //                 optIn: this.optIn,
    //                 termsAndConditions: this.termsAndConditions,
    //                 optInAsked: true,
    //                 specialRequests: this.specialRequests,
    //                 paymentNonce,
    //                 adults: this.adults,
    //                 systemNotes: this.getSystemNotes(),
    //                 specialAvailabilityCode: spa
    //             });

    //             if (result.status == 400) {
    //                 //  bad request
    //                 this.error = true;
    //                 this.errorText = "Could not complete booking:"
    //                 var errors = [];
    //                 for (var i in result.json) {
    //                     errors.push(result.json[i][0]);
    //                 }
    //                 this.errors = errors;
    //             }
    //             else if (result.status == 200) {
    //                 //  we are good - this means we can complete the booking
    //                 //  or we require CCG
    //                 if (!result.json.requiresCcg) {
    //                     this.bookingReference = result.json.bookingReference;
    //                     this.requiresCcg = false;
    //                     this.ccgPerformed = result.json.ccgPerformed;
    //                 }
    //                 else {
    //                     await this.initializeCcgProcess();
    //                 }
    //             }
    //             else {
    //                 //  handle the generic, fallout error
    //                 this.error = true;
    //                 this.errorText = "Could not complete booking:";
    //                 this.errors = ["Unexpected / Unknown error"];
    //             }
    //         }
    //         finally {
    //             this.requestRunning = false;
    //         }
    //     }

    // }


    // completeEnquiry = async () => {
    //     if (this.firstName == null || this.firstName.trim() == '')
    //         this.showFirstNameError = true;
    //     if (this.lastName == null || this.lastName.trim() == '')
    //         this.showLastNameError = true;
    //     if (this.telephoneNumber == null || this.telephoneNumber.trim() == '' || !validateTelephoneNumber(this.telephoneNumber))
    //         this.showTelephoneNumberError = true;
    //     if (this.email == null || this.email.trim() == '' || !validateEmail(this.email))
    //         this.showEmailError = true;

    //     /*if (!this.termsAndConditions)
    //         this.showTermsAndConditionsError = true;*/

    //     //  ensure we are valid
    //     if (!this.showFirstNameError && !this.showLastNameError && !this.showTelephoneNumberError && !this.showEmailError && !this.showTermsAndConditionsError) {
    //         try {
    //             this.requestRunning = true;
    //             //  ok, we are valid... time to do a post
    //             var result = await postJSON("/api/enquiries/create", {
    //                 venueId: this.venue.id,
    //                 date: fromatDateForUrl(this.date),
    //                 time: formatTimeSlotForUrl(this.timeSlot),
    //                 guests: this.guests,
    //                 email: this.email,
    //                 firstName: this.firstName,
    //                 lastName: this.lastName,
    //                 telephoneNumber: this.telephoneNumber,
    //                 optIn: this.optIn,
    //                 termsAndConditions: this.termsAndConditions,
    //                 specialRequests: this.specialRequests,
    //                 optInAsked: true,
    //                 systemNotes: this.getSystemNotes(),
    //                 adults: parseInt(this.guests),
    //                 children: parseInt(this.children || 0)
    //             });

    //             if (result.status == 400) {
    //                 //  bad request
    //                 this.error = true;
    //                 this.errorText = "Could not complete enquiry:"
    //                 var errors = [];
    //                 for (var i in result.json) {
    //                     errors.push(result.json[i][0]);
    //                 }
    //                 this.errors = errors;
    //             }
    //             else if (result.status == 200) {
    //                 //  we are good - this means we can complete the booking
    //                 this.enquiryReference = result.json.enquiryReference;
    //             }
    //             else {
    //                 //  handle the generic, fallout error
    //                 this.error = true;
    //                 this.errorText = "Could not complete enquiry:";
    //                 this.errors = ["Unexpected / Unknown error"];
    //             }
    //         }
    //         finally {
    //             this.requestRunning = false;
    //         }
    //     }
    // }

    // getSystemNotes = () => {
 
    //     var notes = [];
    //     if (this.venue.configuration.insideOrOutside) {
    //         notes.push(this.insideOrOutside);

    //         if (this.insideOrOutside == "Outside") {
    //             notes.push("Please confirm to guest")
    //         }
            
    //     }
    //     var bookingSource = getParameterByName("booking_source");

    //     if (bookingSource) {
    //         notes.push(bookingSource);
    //     }
    //     else {
    //         //Look for booking source in cookies
    //         var allCookieArray = document.cookie.split(';');

    //         for (var i = 0; i < allCookieArray.length; i++) {
    //             let cookie = allCookieArray[i];
    //             //Remove whitespace
    //             while (cookie.charAt(0) == ' ') {
    //                 cookie = cookie.substring(1);
    //             }
    //             if (cookie.indexOf("booking_source") == 0) {
    //                 notes.push(cookie.substr(15)); //Remove 'booking_source=' from the string and leave the value
    //                 break;
    //             }
    //         }
    //     }

    //     return notes;
    // }

    // getConfirmationMessage = () => {
 
    //     var confirmationMessage = null;
    //     if (this.venue.configuration.insideOrOutside) {
    //         if (parseInt(this.guests) + parseInt(this.children || 0) <= 6 &&
    //             this.insideOrOutside === "Outside") {
    //             confirmationMessage = "Your table is booked! We’ll do our best to give you an outside table, but we’ll confirm with you via text 24 hours before.";
    //         }
    //     }
    //     return confirmationMessage;
    // }

    // setFirstName = (v) => {
    //     this.firstName = v;
    //     this.showFirstNameError = this.firstName == null || this.firstName.trim() == '';
    // }

    // setLastName = (v) => {
    //     this.lastName = v;
    //     this.showLastNameError = this.lastName == null || this.lastName.trim() == '';
    // }

    // setEmail = (v) => {
    //     this.email = v;
    //     this.showEmailError = this.email == null || this.email.trim() == '' || !validateEmail(this.email);
    // }

    // setTelephoneNumber = (v) => {
    //     this.telephoneNumber = v;
    //     this.showTelephoneNumberError = this.telephoneNumber == null || this.telephoneNumber.trim() == '' || !validateTelephoneNumber(this.telephoneNumber);
    // }

    // setTermsAndConditions = (v) => {
    //     this.termsAndConditions = v;
    //     this.validateTermsAndConditions();
    // }

    // validateTermsAndConditions = () => {
    //     const accepted = this.confirmations ? this.confirmations.filter(c => c).length : 0;
    //     const required = this.venue.configuration.confirmations ? this.venue.configuration.confirmations.length : 0;
    //     this.showTermsAndConditionsError = !this.termsAndConditions
    //         || accepted != required;
    // }

    // setConfirmations = (index, v) => {
    //     while (this.confirmations.length < index + 1)
    //         this.confirmations.push(false);

    //     this.confirmations[index] = v;
    //     this.validateTermsAndConditions();
    // }

    // setQuestions = (index, v) => {
    //     while (this.questions.length < index + 1)
    //         this.questions.push(false);

    //     this.questions[index] = v;
    // }

    // setCcgTermsAndConditions = (v) => {
    //     this.ccgTermsAndConditions = v;
    // }

    // setOptIn = (v) => {
    //     this.optIn = v;
    // }

    // setSpecialRequests = (v) => {
    //     this.specialRequests = v;
    // }

    // setNumberOfAdults = (v, selected) => {
    //     this.numberOfAdults = v;

    //     var temp = this.adults

    //     this.adults = observable(Array(v).fill(null).map(() => observable({
    //         firstName: '',
    //         lastName: '',
    //         telephoneNumber: '',
    //         showFirstNameError: false,
    //         showLastNameError: false,
    //         showTelephoneNumberError: false
    //     })));


    //     for (var i = 0; i < this.adults.length; i++) {
    //         if (temp.length > i) {
    //             this.adults[i].firstName = temp[i].firstName;
    //             this.adults[i].lastName = temp[i].lastName;
    //             this.adults[i].telephoneNumber = temp[i].telephoneNumber;
    //             this.adults[i].showFirstNameError = temp[i].showFirstNameError;
    //             this.adults[i].showLastNameError = temp[i].showLastNameError;
    //             this.adults[i].showTelephoneNumberError = temp[i].showTelephoneNumberError;
    //         }
    //     }

    //     this.showAdditionalGuestsError = !selected;
    //     this.additionalGuestSelected = selected;
    // }

    // setAdultFirstName = (i, v) => {
    //     this.adults[i].firstName = v;
    //     this.adults[i].showFirstNameError = v == null || v.trim() == '';
    // }

    // setAdultLastName = (i, v) => {
    //     this.adults[i].lastName = v;
    //     this.adults[i].showLastNameError = v == null || v.trim() == '';
    // }

    // setAdultTelephoneNumber = (i, v) => {
    //     this.adults[i].telephoneNumber = v;
    //     this.adults[i].showTelephoneNumberError = v == null || v.trim() == '' || !validateTelephoneNumber(v);
    // }

    // setInvalidAdult = (v) => {
    //     this.invalidAdult = null;
    // }

    // clearError = () => {
    //     this.error = false;
    //     this.errorText = null;
    //     this.errors = null;
    // }


    // confirmCompleteBooking = () => {
    //     this.complete = true;
    //     this.bookingReference = null;
    // }

    // confirmCompleteEnquiry = () => {
    //     this.enquiry = false;
    //     this.enquiryReference = null;
    //     this.complete = true;
    // }

    // hasSelectedGuests = () => {
    //     return (this.guests != null);
    // }

    // setInsideOrOutside = (e) => {
    //     if (!e.target.value)
    //         this.timeSlot = null;
    //     this.insideOrOutside = e.target.value;
    // }
    }}

// decorate(BookingProcess, {
//     step: observable
    // date: observable,
    // venue: observable,
    // timeSlot: observable,
    // guests: observable,
    // children: observable,
    // sessions: observable,
    // showCrossSell: observable,
    // venueAvailability: observable,
    // confirmedTimeSlot: observable,
    // specialRequests: observable,

    // //  meuu process
    // menusAvailable: observable,
    // menus: observable,
    // menu: observable,
    // showMenuError: observable,
    // confirmedMenu: observable,

    // //  customer details
    // firstName: observable,
    // lastName: observable,
    // telephoneNumber: observable,
    // email: observable,
    // optIn: observable,
    // termsAndConditions: observable,
    // confirmations: observable,
    // questions: observable,

    // showFirstNameError: observable,
    // showLastNameError: observable,
    // showTelephoneNumberError: observable,
    // showEmailError: observable,
    // showTermsAndConditionsError: observable,

    // requestRunning: observable,
    // error: observable,
    // errorText: observable,
    // errors: observable,
    // complete: observable,

    // enquiry: observable,
    // enquiryReference: observable,

    // requiresCcg: observable,
    // ccgPerformed: observable,
    // ccgTermsAndConditions: observable,
    // showCcgTermsAndConditionsError: observable,

    // numberOfAdults: observable,
    // adults: observable,

    // invalidAdult: observable,
    // showAdditionalGuestsError: observable,
    // additionalGuestSelected: observable,

    // insideOrOutside: observable
// });


export default new BookingProcess();